import React, { useState, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import PageHeader from "../header/pageheader/PageHeader";
import "./styles.css";
import UniversalForm from "../forms/UniversalForm";
import UniversalTable from "./table/UniTable";
import Modal from "../forms/wrap/Modal";
import { toast } from "react-toastify";
import CustomToastContainer from "../forms/notification/CustomToastContainer";
import ConfirmToast from "../forms/notification/Confirm";
import { useModal } from "../hooks/useModal";
import { logApiError } from "../../utils/logApiError";
import OrgApiKeyActions from "./OrgApiKeyActions";

export default observer(function Organization() {
  const { store, uploadStore } = useContext(Context);
  const modal = useModal(false);
  const navigate = useNavigate();

  const [mode, setMode] = useState<"create" | "edit">("create");
  const [searchTerm, setSearchTerm] = useState("");

  const filteredItems = store.companies.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  async function createOrg(data) {
    try {
      const newOrg = await store.createOrganization(data);

      toast(
        <ConfirmToast
          message={`API-ключ: ${newOrg.apiKey}`}
          onConfirm={() => handleCloseModal()}
          type={"del"}
          title={"ок"}
        />,

        {
          style: {
            borderRadius: 0,
          },
          progressClassName: "toast-progress-delete",
          autoClose: false,
        },
      );

      handleCloseModal();
    } catch (error) {
      // обработка ошибки уже в store, но можно и здесь
    }
  }

  async function editOrganization(Data) {
    try {
      await store.editOrganization(Data);
      handleCloseModal();
    } catch (error) {
      logApiError("Ошибка при сохранении организации:", error);
    }
  }

  function Create() {
    setMode("create");
    modal.open();
  }
  function Edit() {
    setMode("edit");
    modal.open();
  }

  function Serch(target: string) {
    setSearchTerm(target);
  }

  const setOrg = useCallback(
    (company: Company | null) => {
      store.setCompany(company);
    },
    [store],
  );

  const goToPlant = (company: object) => {
    setOrg(company);
    navigate("/plants");
  };

  function delOrg(id: number) {
    store.deleteCompany(id);
    setOrg({});
  }

  const handleCloseModal = useCallback(() => {
    setOrg({});
    modal.close();
  }, [setOrg, modal]);

  async function handleLogoUpload(file: File) {
    const url = await uploadStore.uploadOrgLogo(file, store.company?.id);
  }

  const itemsToDisplay = searchTerm ? filteredItems : store.companies;
  const companyId = store.company?.id;
  const apiKeyActions =
    store.user?.role === "root" && companyId ? (
      <OrgApiKeyActions
        isRoot
        onReissue={async () => {
          const result = await store.reissueOrgApiKey(companyId);
          return result.apiKey;
        }}
        onRevoke={async () => {
          await store.revokeOrgApiKey(companyId);
        }}
      />
    ) : null;

  return (
    <>
      <div className="org_conteiner">
        <PageHeader
          title="ОРГАНИЗАЦИИ"
          buttontext="Создать организацию"
          onCreate={Create}
          onSearch={Serch}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
        <UniversalTable
          data={itemsToDisplay}
          type="organizations"
          setOrg={setOrg}
          Edit={Edit}
          goto={goToPlant}
        />
      </div>

      <Modal isOpen={modal.isOpen} onClose={modal.close}>
        <UniversalForm
          handleCloseModal={handleCloseModal}
          mode={mode}
          entityData={store.company}
          fields={{
            name: { label: "Название", required: true },
            location: { label: "Город" },
            adress: { label: "Адрес" },
            description: { label: "Описание" },
          }}
          createEntity={createOrg}
          editEntity={editOrganization}
          deleteEntity={delOrg}
          title="Создать организацию"
          withPhotoUpload={true}
          onPhotoUpload={handleLogoUpload}
          entity={store.company?.name}
          extraActions={apiKeyActions}
        />
      </Modal>
      <CustomToastContainer />
    </>
  );
});
